<template>
    <div>
        <div class="container-md ">
            <div class=" container-bg p-5 ">
                <div class="row">
                    <div class="col-lg-10 col-md-6 col-sm-6">
                        <h3 class="text-uppercase">MESSAGES - INTERNAL COMMUNICATION</h3>

                    </div>
                    <div class="col-lg-2 col-md-6 col-sm-6">
                        <i class="fa fa-plus float-right " data-toggle="modal" data-target="#newItemgroup"
                           style="font-size: 24px;cursor: pointer"></i>
                    </div>

                </div>


                <div class="row">
                    <div class="col-lg-5 col-md-12 col-sm-12">
                        <div class="col-12" style="background-color: #4192D9;border-radius: 4px 4px 0px 0px;">
                            <div class="search-container ml-3">
                                <form action="#">
                                    <input type="text" placeholder="Zoeken" name="search" style="margin-top: 15px;
                           border-color: white;
                           border-radius: 5px;

                            width: 96%;
                           border-style: none;
                          ">
                                    <button type="submit" style="
                           border-style: none;
                           background-color: white;
                           border-radius: 5px;
                           margin-left: -25px;"><i class="fa fa-search"></i></button>
                                </form>
                            </div>

                            <div class="card-div m-3" style=" background-color: white;
                     width: 262px;
                     border-radius: 5px;">
                                <span style="color: #6C6C6C; margin-left: 204px;">5h ago</span>
                                <img src="./../../../assets/images/adult-1851571_1920.png" style="margin-left: 15px;">
                                <h5 style="color: #6C6C6C; margin-top: -46px;
                        margin-left: 70px;">Name Person</h5>
                                <p style="color: #6C6C6C; margin-left: 70px;
                        margin-top: -8px;">Title message lorem ipsum dolor set</p>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div style="background-color: #6C6C6C;
                              width: 80px;
                              height: 25px;
                              border-radius: 5px;
                              margin-left: 9px;
                              margin-top: -10px;">
                              <span class="text-center" style="    color: white;
                                 font-size: 14px; margin-left: 4px;">Muzikanten</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Fill.svg" style="    height: 16px;
                              margin-top: -23px; margin-right: 6%;">
                                        <img src="/assets/img/trash-alt.svg" style="    height: 16px;
                              margin-top: -23px;">
                                    </div>
                                </div>
                            </div>

                            <div class="card-div m-3" style=" background-color: white;
                     width: 262px;
                     border-radius: 5px;">
                                <span style="color: #6C6C6C; margin-left: 204px;">5h ago</span>
                                <img src="./../../../assets/images/adult-1851571_1920.png" style="margin-left: 15px;">
                                <h5 style="color: #6C6C6C; margin-top: -46px;
                        margin-left: 70px;">Name Person</h5>
                                <p style="color: #6C6C6C; margin-left: 70px;
                        margin-top: -8px;">Title message lorem ipsum dolor set</p>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div style="background-color: #6C6C6C;
                              width: 80px;
                              height: 25px;
                              border-radius: 5px;
                              margin-left: 9px;
                              margin-top: -10px;">
                              <span class="text-center" style="    color: white;
                                 font-size: 14px; margin-left: 4px;">Muzikanten</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Fill.svg" style="    height: 16px;
                              margin-top: -23px; margin-right: 6%;">
                                        <img src="/assets/img/trash-alt.svg" style="    height: 16px;
                              margin-top: -23px;">
                                    </div>
                                </div>
                            </div>

                            <div class="card-div m-3" style=" background-color: white;
                     width: 262px;
                     border-radius: 5px;">
                                <span style="color: #6C6C6C; margin-left: 204px;">5h ago</span>
                                <img src="./../../../assets/images/adult-1851571_1920.png" style="margin-left: 15px;">
                                <h5 style="color: #6C6C6C; margin-top: -46px;
                        margin-left: 70px;">Name Person</h5>
                                <p style="color: #6C6C6C; margin-left: 70px;
                        margin-top: -8px;">Title message lorem ipsum dolor set</p>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div style="background-color: #6C6C6C;
                              width: 80px;
                              height: 25px;
                              border-radius: 5px;
                              margin-left: 9px;
                              margin-top: -10px;">
                              <span class="text-center" style="    color: white;
                                 font-size: 14px; margin-left: 4px;">Muzikanten</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Fill.svg" style="    height: 16px;
                              margin-top: -23px; margin-right: 6%;">
                                        <img src="/assets/img/trash-alt.svg" style="    height: 16px;
                              margin-top: -23px;">
                                    </div>
                                </div>
                            </div>
                            <div class="card-div m-3" style=" background-color: white;
                     width: 262px;
                     border-radius: 5px;">
                                <span style="color: #6C6C6C; margin-left: 204px;">5h ago</span>
                                <img src="./../../../assets/images/adult-1851571_1920.png" style="margin-left: 15px;">
                                <h5 style="color: #6C6C6C; margin-top: -46px;
                        margin-left: 70px;">Name Person</h5>
                                <p style="color: #6C6C6C; margin-left: 70px;
                        margin-top: -8px;">Title message lorem ipsum dolor set</p>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div style="background-color: #6C6C6C;
                              width: 80px;
                              height: 25px;
                              border-radius: 5px;
                              margin-left: 9px;
                              margin-top: -10px;">
                              <span class="text-center" style="    color: white;
                                 font-size: 14px; margin-left: 4px;">Muzikanten</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Fill.svg" style="    height: 16px;
                              margin-top: -23px; margin-right: 6%;">
                                        <img src="/assets/img/trash-alt.svg" style="    height: 16px;
                              margin-top: -23px;">
                                    </div>
                                </div>
                            </div>
                            <div class="card-div m-3" style=" background-color: white;
                     width: 262px;
                     border-radius: 5px;">
                                <span style="color: #6C6C6C; margin-left: 204px;">5h ago</span>
                                <img src="./../../../assets/images/adult-1851571_1920.png" style="margin-left: 15px;">
                                <h5 style="color: #6C6C6C; margin-top: -46px;
                        margin-left: 70px;">Name Person</h5>
                                <p style="color: #6C6C6C; margin-left: 70px;
                        margin-top: -8px;">Title message lorem ipsum dolor set</p>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div style="background-color: #6C6C6C;
                              width: 80px;
                              height: 25px;
                              border-radius: 5px;
                              margin-left: 9px;
                              margin-top: -10px;">
                              <span class="text-center" style="    color: white;
                                 font-size: 14px; margin-left: 4px;">Muzikanten</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Fill.svg" style="    height: 16px;
                              margin-top: -23px; margin-right: 6%;">
                                        <img src="/assets/img/trash-alt.svg" style="    height: 16px;
                              margin-top: -23px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-12 col-sm-12" style="padding: 0;">
                        <div class="col-md-12 col-sm-12"
                             style="background-color: #4192D9; height: 100%; border-radius: 5px;">
                            <div class="row" style="background-color: white;
    width:107.3%;
    border-radius: 5px;">


                                <div class="col-lg-6 col-md-12 col-sm-12 mt-2">
                                    <h5>Person Name</h5>
                                    <span>Title message lorem ipsum dolor set</span>
                                </div>
                                <div class="col-lg-2 col-md-6 col-sm-12" style="    margin-left: -47px;">
                                    <div style="background-color: #6C6C6C;
    width: 134px;

    border-radius: 5px;
    color: white;
    margin-top: 26px;
    padding-left: 4px;">
                                        <span>Liedjes commissie</span>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-6 col-sm-12" style="padding-left: 83px;
    margin-top: 5%;">
                                    <img src="./../../../assets/images/adult-1851571_1920.png"
                                         style="width: 35px;margin-left: -8px;border:1px solid #FFFFFF;border-radius: 50%"
                                         alt="">
                                    <img src="./../../../assets/images/adult-1851571_1920.png"
                                         style="width: 35px;
    margin-left: 18px;
    margin-top: -61px;border:1px solid #FFFFFF;border-radius: 50%"
                                         alt="">
                                </div>
                                <div class="col-lg-2 col-md-6 col-sm-12" style="    margin-top: 41px;
    margin-left: 30px;
">
                                    <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                    <img src="/assets/img/Fill.svg" style="    height: 16px;
                              margin-top: -23px; margin-right: 6%;">
                                    <img src="/assets/img/trash-alt.svg" style="    height: 16px;
                              margin-top: -23px;">
                                </div>

                            </div>


                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <span style="width: 51px;
    height: 18px;
    background-color: white;
    padding: 2px 18px;
    border-radius: 5px;     margin-left: 39%;">Today</span>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-lg-2 col-sm-12">
                                    <img src="./../../../assets/images/adult-1851571_1920.png" style="border-radius: 50%;
    border: 4px solid;
    color: white;">
                                </div>
                                <div class="col-lg-10 col-sm-12">
                                    <div style="width: 100%;
    height: 95%;
    background-color: white;
    margin-left: -6%;
    box-shadow: 1px 5px 10px #00000029;
    border-radius: 4px;padding: 18px;">
                                        <span>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.</span><br>

                                        <p style="margin-top: 20px;">Et harum quidem rerum facilis est et expedita
                                            distinctio?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-sm-12 col-md-12">
                                    <p style="color: white; margin-left: 82%;
    margin-top: 0%;">1h ago</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <div style="    width: 100%;
    height: 100%;
background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 1px 5px 10px #00000029;
border-radius: 4px; padding: 15px;">
                                        <span>Molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.</span>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-sm-2 col-md-2">
                                    <img src="./../../../assets/images/adult-1851571_1920.png" style="border-radius: 50%;
    border: 4px solid;
    color: white; margin-left: -7px;">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-sm-12 col-md-12">
                                    <p style="color: white; margin: 6px;">5 minutes ago</p>
                                </div>
                            </div>

                            <div class="row mt-5" style="background-color: white; width:106.5%;
    box-shadow: 1px -2px 10px #00000029;
border-radius: 4px 4px 0px 0px;
opacity: 1;     padding: 27px 27px 35px 27px;">


                                <div class="col-lg-10 col-md-10 col-sm-8">

                        <textarea style="width: 100%;
height: 195px; background: #FFFFFF 0% 0% no-repeat padding-box;
border: 1px solid #C4C7D5;
border-radius: 4px;
opacity: 1;"></textarea>

                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-4" style="    position: absolute;
    bottom: 40px;
    margin-left: 73%;
    margin-top: -7px;">
                                    <div>
                                        <img src="/assets/img/attach.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Layer_2.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                        <img src="/assets/img/Settings.svg" style="    height: 16px;
                              margin-top: -23px;  margin-right: 6%;">
                                    </div>
                                    <button style="width: 119%;

background: #292929 0% 0% no-repeat padding-box;
border-radius: 4px;
opacity: 1; color: white;">Send
                                    </button>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>
            </div>


        </div>
        <!-- Modal -->
        <div class="modal fade" id="newItemgroup" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
             aria-hidden="true">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: unset">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "messages",
    }
</script>

<style scoped>

</style>
